import ProjectManagerPage from './ProjectManager';

export default ProjectManagerPage;
